import { withMetadata } from '../metadata'
import { formatIncompletePhoneNumber as _formatIncompletePhoneNumber } from '../../core/index'

export function formatIncompletePhoneNumber() {
	return withMetadata(_formatIncompletePhoneNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/formatIncompletePhoneNumber.js
// module id = 638
// module chunks = 0